import { useEffect } from "react";
import { selectPage, usePcpLiveLessonContext } from "../store";

/**
 * This hook should hide the global DOM elements
 * - `pcp-extension-app-student-wrapper` and
 * - `pcp-extension-app-beamer-wrapper`
 * which are used to render `PushTheButton` and `PracticeTrainer`.
 *
 * Depending on the current page, the elements should be shown or hidden:
 * - shown when the current page is `CallPage`
 * - hidden on all other pages
 * - hidden by default
 */
export const useHideExtensionApps = (): void => {

    const page = usePcpLiveLessonContext(selectPage);

    const show = (element: null|HTMLElement) => {
        if (element) {
            element.style.display = 'block';
        }
    };
    const hide = (element: null|HTMLElement) => {
        if (element) {
            element.style.display = 'none';
        }
    }

    useEffect(() => {
        const studentWrapper = document.querySelector<HTMLElement>('pcp-extension-app-student-wrapper');
        const beamerWrapper = document.querySelector<HTMLElement>('pcp-extension-app-beamer-wrapper');

        if (page === 'call') {
            show(studentWrapper);
            show(beamerWrapper);
        } else {
            hide(studentWrapper);
            hide(beamerWrapper);
        }
    }, [page])
};
